module.exports = __webpack_public_path__ + "static/media/en-cancel-service_5.f4d3018b.png";